export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: "蜜桃传媒的服务流程是怎样的？",
    answer: "我们的服务流程分为五步：需求沟通（深入了解品牌诉求和目标）→ 策略制定（输出定制化内容营销方案）→ 内容创作（专业团队落地执行）→ 发布运营（多平台精准分发）→ 数据复盘（效果评估与策略优化）。全程有专属项目经理跟进，确保高效沟通和品质交付。"
  },
  {
    question: "合作的最小周期是多长？",
    answer: "根据服务内容不同，合作周期灵活可选。单品内容制作最快3-5个工作日交付；月度运营合作建议至少3个月起，以确保策略的持续性和效果的稳定性；年度框架合作可享受更优惠的价格和更深入的服务。"
  },
  {
    question: "蜜桃传媒服务过哪些行业的客户？",
    answer: "我们的客户覆盖美妆护肤、食品饮料、3C数码、家居生活、教育培训、餐饮连锁、文旅酒店等多个行业。无论您是成熟品牌还是新锐品牌，我们都能提供匹配的解决方案。"
  },
  {
    question: "如何保证内容的原创性和品质？",
    answer: "我们建立了严格的内容品控体系：所有内容均由内部专业团队原创制作，每篇内容经过策划、创作、审核三重把关。我们为每个项目配备资深内容总监全程把控品质，确保输出的内容既符合品牌调性，又具备传播力。"
  },
  {
    question: "合作的费用如何计算？",
    answer: "费用根据服务类型、内容数量、制作难度等因素综合评估。我们提供单品报价、月度套餐、年度框架三种合作模式。具体费用请在需求沟通后，由我们的商务团队提供详细报价方案。"
  },
  {
    question: "如何开始与蜜桃传媒合作？",
    answer: "您可以通过官网的「联系我们」表单提交合作需求，或直接拨打我们的商务热线。我们的商务团队会在24小时内与您联系，了解您的具体需求，并安排进一步沟通。"
  }
];